import { useEffect, useRef } from 'react';

/*
 * The kit's open layers (a sheet, a popover), newest last, each with its way to close. Radix
 * gives Escape to the newest dismissable layer, and a toast that's up is one: without this,
 * Escape in a sheet would close the slip instead for its 2.4 seconds. The toast hands Escape
 * down to the layer under it (ui/Toast.tsx).
 */
const layers: (() => void)[] = [];

/** While `open`, this layer closes with `close` when Escape is handed down to it. */
export function useLayer(open: boolean, close: () => void): void {
	const ref = useRef(close);
	ref.current = close;
	useEffect(() => {
		if (!open) return;
		const entry = () => ref.current();
		layers.push(entry);
		return () => {
			const i = layers.lastIndexOf(entry);
			if (i >= 0) layers.splice(i, 1);
		};
	}, [open]);
}

/** Escape reached a toast: close the newest layer under it instead. True if there was one. */
export function escapeToLayerBelow(): boolean {
	const top = layers[layers.length - 1];
	if (!top) return false;
	top();
	return true;
}
